import { Loader } from "@googlemaps/js-api-loader";
import { TileLayer } from "./tile-layer.js";
import { Marker } from "./marker.js";
export const getGMapImplementationWrapper = async (options) => {
    let loader = new Loader(options);
    let { Map } = await loader.importLibrary("maps");
    const { AdvancedMarkerElement } = await loader.importLibrary("marker");
    const wrapper = {
        create: (mapContainer, bounds, center, zoom) => {
            if (bounds === undefined &&
                (center === undefined || zoom === undefined)) {
                throw new Error("Bounds or center & zoom must be provided");
            }
            var mapOptions = {
                styles: [
                    {
                        featureType: "poi",
                        elementType: "all",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "transit.station",
                        elementType: "all",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                ],
                disableDefaultUI: true,
                draggableCursor: "default",
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapId: options.mapId,
                tilt: 0,
            };
            const map = new Map(mapContainer, mapOptions);
            return map;
        },
        destroy: (map) => {
            if (map) {
                map.controls.forEach(function (control) {
                    control.clear();
                });
                google.maps.event.clearInstanceListeners(map);
            }
            return map;
        },
        set: (map, bounds, center, zoom) => {
            if (map) {
                if (bounds) {
                    map.fitBounds({
                        east: bounds.northEast.lng,
                        north: bounds.northEast.lat,
                        west: bounds.southWest.lng,
                        south: bounds.southWest.lat,
                    });
                }
                else if (center && zoom !== undefined) {
                    map.setCenter(center);
                    map.setZoom(zoom);
                }
                else {
                    throw new Error("Parameter 'bounds' or 'center' & 'zoom''must be provided");
                }
            }
        },
        addHandler: (map, eventName, handler) => {
            return map.addListener(eventName, handler);
        },
        removeHandler: (map, handlerKey) => {
            google.maps.event.removeListener(handlerKey);
        },
        addLatLngTracker: (map, handler) => {
            const moveKey = wrapper.addHandler(map, "mousemove", (ev) => {
                handler(ev.latLng
                    ? { lat: ev.latLng.lat(), lng: ev.latLng.lng() }
                    : undefined);
            });
            const outKey = wrapper.addHandler(map, "mouseout", (ev) => {
                handler(undefined);
            });
            return { moveKey, outKey };
        },
        removeLatLngTracker: (map, trackerKey) => {
            wrapper.removeHandler(map, trackerKey.moveKey);
            wrapper.removeHandler(map, trackerKey.outKey);
        },
        createTileLayer: () => new TileLayer(),
        createMarker: (latLng, content) => {
            const gmarker = new AdvancedMarkerElement({
                //      map:<GMap>map,
                position: latLng,
                content,
            });
            return new Marker(gmarker);
        },
    };
    return wrapper;
};
